import { render, staticRenderFns } from "./ItemTop.vue?vue&type=template&id=0de4543c&"
import script from "./ItemTop.vue?vue&type=script&lang=js&"
export * from "./ItemTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports